
export const NONE                  = Symbol('NONE');

export const CLASS_O_MAT           = Symbol('CLASS_O_MAT'); 
export const CLASS_O_MAT_GROUP     = Symbol('CLASS_O_MAT_GROUP'); 
export const ACCESSORS_O_MAT       = Symbol('ACCESSORS_O_MAT'); 
export const API_FIELD_O_MAT       = Symbol('API_FIELD_O_MAT');
export const API_METHOD_O_MAT      = Symbol('API_METHOD_O_MAT');
export const FIELD_O_MAT           = Symbol('FIELD_O_MAT');
export const FIELD_VALIDATOR_O_MAT = Symbol('FIELD_VALIDATOR_O_MAT');


export const CHILD_ADDER_O_MAT     = Symbol('CHILD_ADDER_O_MAT');
export const COPIER_O_MAT          = Symbol('COPIER_O_MAT');
export const TEST_CLASS            = Symbol('TEST_CLASS');
export const TO_SET                = Symbol('TO_SET');

export const API_FIELD             = Symbol('API_FIELD');
export const API_FIELD_DYNAMIC     = Symbol('API_FIELD_DYNAMIC');
export const API_METHOD            = Symbol('API_METHOD');
export const _GROUP                = Symbol('_GROUP');
export const CLASS_GROUP           = Symbol('CLASS_GROUP');
export const O_MAT_GROUP           = Symbol('O_MAT_GROUP');
export const COLLECTION            = Symbol('COLLECTION');
export const STACK                 = Symbol('STACK');
export const QUEUE                 = Symbol('QUEUE');

export const DUPLICATE_UID         = Symbol('DUPLICATE_UID');
export const DUPLICATE_KEY         = Symbol('DUPLICATE_KEY');
export const CLASS_O_MAT_ADDED     = Symbol('SET_ADDED');

export const RADIO                 = Symbol('RADIO');
export const RADIO_OPTION          = Symbol('RADIO_OPTION');

export const CLASS_BUILDER         = Symbol('CLASS_BUILDER');
export const PLUGIN                = Symbol('PLUGIN');
export const PLUGIN_APPENDER       = Symbol('PLUGIN_APPENDER'); 
export const PLUGIN_PREPENDER      = Symbol('PLUGIN_PREPENDER'); 

export const _FIELD_METHOD_O_MAT   = Symbol('_FIELD_METHOD_O_MAT');
export const FIELD_ACTION_O_MAT    = Symbol('FIELD_ACTION_O_MAT');
export const FIELD_REDUCER_O_MAT   = Symbol('FIELD_REDUCER_O_MAT');
